import type { CutsceneAssetV1 } from "@hyperlight/shared";

/** Authored in a procedural hometown-relative rig, so it works for every home world. */
export const HOMECOMING_CUTSCENE: CutsceneAssetV1 = {
  v: 1,
  id: "homecoming-v1",
  duration: 12,
  skippable: true,
  camera: [
    { t: 0, position: [-520, 420, -760], target: [0, 10, 80], fov: 62, ease: "smooth" },
    { t: 3.4, position: [-150, 155, -290], target: [0, 18, 65], fov: 56, ease: "smooth" },
    { t: 6.8, position: [64, 48, -112], target: [0, 8, 45], fov: 50, ease: "smooth" },
    { t: 9.2, position: [18, 9, -24], target: [0, 1.2, 8], fov: 45, ease: "ease-out" },
    { t: 12, position: [4.2, 2.4, -6.5], target: [0, 1.15, 8], fov: 58, ease: "smooth" },
  ],
  cues: [
    { start: .5, end: 3.1, eyebrow: "YOUR HOME WORLD", text: "{world}" },
    { start: 4.1, end: 7.1, eyebrow: "YOUR HOMETOWN", text: "{hometown}" },
    { start: 8.1, end: 11.2, eyebrow: "THE ROAD AHEAD", text: "{capital} · {distance} KM" },
  ],
};
